<div class="w-full p-20 bg-pastel-blue border-box h-full scroll-y">
  <div class="flex gap-20 mb-20">
    <div>
      <img src="assets/pap-icon.svg" alt="list">
    </div>
    <div>
      <h3 class="light-blue no-margin text-lg">Générer automatiquement votre modèle de PAP en toute simplicité</h3>
      <p class="dark-gray no-margin text-sm">Ces informations sont nécessaires pour générer votre protocole d'accord
        préélectoral.</p>
    </div>
  </div>

  <div class="flex flex-column gap-20">
    <div class="p-20 bg-white border-box">
      <p class="dark-blue no-margin bold">
        Souhaitez-vous saisir les données nécessaires à la génération de votre modèle PAP ?
      </p>
      <p class="dark-gray text-sm mb-10">
        Pour générer un document conforme et personnalisé, nous vous invitons à renseigner les paramètres spécifiques de
        votre entreprise. Cette étape permet d'automatiser le calcul de la répartition des sièges, d'établir votre
        calendrier électoral sur mesure et d'intégrer les clauses spécifiques au vote électronique. En quelques minutes,
        vous obtiendrez une base solide pour engager vos négociations avec les organisations syndicales.
      </p>
      <div>
        <div class="flex gap-10">
          <label class="flex align-items-center gap-5 pointer">
            <input type="radio" name="needPap" [value]="true" [(ngModel)]="needPap"> Oui
          </label>
          <label class="flex align-items-center gap-5 pointer">
            <input type="radio" name="needPap" [value]="false" [(ngModel)]="needPap"> Non
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="needPap == false" class="bg-white p-20 flex flex-column gap-20">
      <div class="flex content-center gap-20">
        <img src="assets/clouds-icon.svg" alt="list">
        <img src="assets/ballot-icon.svg" alt="list">
        <img src="assets/clouds-icon.svg" alt="list">
      </div>
      <div>
        <h2 class="dark-blue no-margin text-center mb-5">Vous pouvez passer directement à l'étape suivante.</h2>
        <p class="mb-20 grey no-margin text-center text-sm">
          Le protocole d'accord préélectoral ne sera pas généré automatiquement.
        </p>
      </div>
      <div class="margin-center w-fit">
        <button class="action-button" (click)="goToCerfa()">Passer à la génération du CERFA</button>
      </div>
    </div>

    <div *ngIf="needPap" class="flex flex-column gap-20">
      <app-pap-information [(venue)]="papValues.venue" (venueChange)="onVenueChanges()"></app-pap-information>
      <app-pap-employer [(employer)]="papValues.employer" (employerChange)="onPapValuesChange()"></app-pap-employer>
      <app-pap-union [(unions)]="papValues.unions" (unionsChange)="onPapValuesChange()"></app-pap-union>
      <app-pap-length [(termLength)]="papValues.termLength" (termLengthChange)="onPapValuesChange()"></app-pap-length>
      <app-pap-period [(period)]="papValues.period" (periodChange)="onPapValuesChange()"></app-pap-period>
      <app-pap-headcount [headcount]="papValues.headcount" (headcountChange)="onHeadcountChange($event)"
        (numberOfCollegesChange)="onNumberOfCollegesChanges()"></app-pap-headcount>
      <app-pap-college [(colleges)]="papValues.colleges" (collegesChange)="onPapValuesChange()"
        [headcount]="papValues.headcount" [partial]="papValues.termLength.partial"></app-pap-college>
      <app-pap-application [(application)]="papValues.application" (applicationChange)="onPapValuesChange()"
        [period]="papValues.period"></app-pap-application>
      <app-pap-year [(year)]="papValues.electionYear" (yearChange)="onPapValuesChange()"></app-pap-year>
    </div>

  </div>

</div>